/**
 * External dependencies
 */

/**
 * WordPress dependencies.
 */
import { compose } from '@wordpress/compose';
import { Button, Icon } from '@wordpress/components';
import { withDispatch } from '@wordpress/data';
import { __ } from '@wordpress/i18n';
import { Component } from '@wordpress/element';

/**
 * Internal dependencies
 */
import BaseWrapper from '../../components/base-wrapper';
import Templates from '../../extensions/plugin-sidebar/templates';
class edit extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			isTemplatesModalOpen: false,
		};

		this.getLayoutsSelector = this.getLayoutsSelector.bind( this );
	}

	getLayoutsSelector() {
		const {
			clientId,
			attributes,
			removeBlock,
		} = this.props;
		return (
			<>
				{ attributes.isTemplatesModalOnly || this.state.isTemplatesModalOpen ? (
					<Templates
						onRequestClose={ () => {
							this.setState( {
								isTemplatesModalOpen: false,
							} );
							if ( attributes.isTemplatesModalOnly ) {
								removeBlock( clientId );
							}
						} }
						replaceBlockId={ clientId }
					/>
				) : (
					''
				) }
			</>
		);
	}
	render() {
		const {
			className,
		} = this.props;
		const openModal = () => {
			this.setState( {
				isTemplatesModalOpen: true,
			} );
		};
		// const closeModal = () => {
		// 	setAttributes( {
		// 		isTemplatesModalOnly: false,
		// 	} );
		// };
		// console.log( attributes.isTemplatesModalOnly || isTemplatesOpen );
		return (
			<div className={ `${ className } gutenify--flex gutenify--flex--justify-center` }>
				{ this.getLayoutsSelector() }
				<BaseWrapper { ...this.props } >
					<Button onClick={ () => openModal() } isPrimary><Icon icon={ 'grid-view' } size={ 16 } /> &nbsp; { __( 'Add Template' ) }</Button>
				</BaseWrapper>
			</div>
		);
	}
}

export default compose( [
	withDispatch( ( dispatch ) => {
		const { updateBlockAttributes, removeBlock, replaceInnerBlocks } = dispatch(
			'core/block-editor'
		);

		return {
			updateBlockAttributes,
			removeBlock,
			replaceInnerBlocks,
		};
	} ),
] )( edit );
